import { useRecoilState } from 'recoil';

import { preventLogInspectorFromClosingState } from 'components/common/Managers/LogInspectorManager.state';

// TODO: (DPVZ-1794) This hook will need to be moved to the plugin SDK when we do the monorepo refactor
export const useLogInspectorState = () => {
  const [ preventLogInspectorFromClosing, setPreventLogInspectorFromClosing ] =
    useRecoilState(preventLogInspectorFromClosingState);

  return {
    isLogInspectorPreventedFromClosing: preventLogInspectorFromClosing,
    preventLogInspectorFromClosing: () => setPreventLogInspectorFromClosing(true),
    allowLogInspectorToClose: () => setPreventLogInspectorFromClosing(false),
  };
};
